var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireIconHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 3.5C23.871 3.5 3.5 23.871 3.5 49C3.5 74.129 23.871 94.5 49 94.5C74.129 94.5 94.5 74.129 94.5 49C94.5 23.871 74.129 3.5 49 3.5ZM0.5 49C0.5 22.2142 22.2142 0.5 49 0.5C75.7858 0.5 97.5 22.2142 97.5 49C97.5 75.7858 75.7858 97.5 49 97.5C22.2142 97.5 0.5 75.7858 0.5 49Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7614 25.8503L58.5901 39.3199C62.5665 45.993 67.9099 52.5425 67.9099 60.5748C67.9099 70.0006 60.7061 77.8224 51.4992 78.8686C51.0139 78.947 50.5165 78.9875 50.0096 78.9875C49.9249 78.9875 49.8405 78.9864 49.7564 78.9841C49.6361 78.9864 49.5155 78.9875 49.3945 78.9875C39.2049 78.9875 31.0034 70.708 31.0034 60.5748C31.0034 52.5425 36.3468 45.993 40.199 39.3199L48.0276 25.7267C48.6489 24.7381 50.2644 24.7381 50.7614 25.8503ZM50.022 53.9747L47.7696 58.2331L45.8099 61.734C44.2588 64.6149 43.629 66.4225 43.629 68.3286C43.629 72.3168 46.5203 75.4774 50.0096 75.4774C53.4989 75.4774 56.3903 72.3168 56.3903 68.3286C56.3903 66.1156 55.5651 64.036 53.4848 60.3272L52.4954 58.5618L50.022 53.9747ZM49.3945 29.6811L42.9328 40.8028C39.4534 46.858 34.11 53.5311 34.11 60.5748C34.11 66.0365 36.9972 70.8195 41.3386 73.4988C40.548 71.9647 40.0992 70.2005 40.0992 68.3286C40.0992 65.3491 41.087 62.888 43.457 58.7067L44.665 56.5628L47.2572 51.6666C47.5475 51.1174 47.9965 50.6673 48.5465 50.3743L48.855 50.2305C50.3141 49.6444 52.0133 50.2341 52.7734 51.645L55.5924 56.8779L56.9947 59.3881C59.0518 63.1464 59.92 65.5106 59.92 68.3286C59.92 69.6927 59.6817 70.9996 59.2463 72.202C62.5698 69.4153 64.679 65.2429 64.679 60.5748C64.679 53.5311 59.4599 46.858 55.9805 40.8028L49.3945 29.6811Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 96,
    y1: 2,
    x2: 2,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EF3FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIconHeader);
export default __webpack_public_path__ + "static/media/fire-icon-header.25239c4b.svg";
export { ForwardRef as ReactComponent };